<div class="provider-card">
    <div class="provider-card__logo">
        @if (row.provider) {
        @if (isAmazonProvider(row.provider)) {
        <span class="provider-logo-wrap" [matTooltip]="getProviderName(row.provider)">
            <img class="provider-logo provider-logo--light" src="assets/images/providers-logos/amazon.png"
                [alt]="getProviderName(row.provider)" />
            <img class="provider-logo provider-logo--dark" src="assets/images/providers-logos/amazon-white.png"
                [alt]="getProviderName(row.provider)" />
        </span>
        } @else {
        <img class="provider-logo" [src]="getProviderLogo(row.provider)" [alt]="getProviderName(row.provider)"
            [matTooltip]="getProviderName(row.provider)" />
        }
        } @else {
        <span class="provider-card__meta-value">---</span>
        }
    </div>

    <div class="provider-card__body">
        <div class="provider-card__meta">
            <div class="provider-card__meta-item provider-card__meta-item--start">
                <span class="provider-card__meta-label">{{ translationPrefix + '.filed_cases' | translate }}</span>
                <span class="provider-card__meta-value">{{ row.filedCases }}</span>
            </div>
            <div class="provider-card__meta-item provider-card__meta-item--end">
                <span class="provider-card__meta-label">{{ translationPrefix + '.unclaimed_total' | translate }}</span>
                <span class="provider-card__meta-value">{{ row.unclaimedTotal }}</span>
            </div>
        </div>

        <div class="provider-card__meta provider-card__meta--full">
            <div class="provider-card__meta-item">
                <span class="provider-card__meta-label">{{ translationPrefix + '.claim_success_rate' | translate }}</span>
                <app-progress-bar-widget [value]="row.claimSuccessRate" [max]="100"
                    [evaluator]="successRateEvaluator" />
            </div>
        </div>

        <div class="provider-card__meta">
            <div class="provider-card__meta-item provider-card__meta-item--start">
                <span class="provider-card__meta-label">{{ translationPrefix + '.cash_reembursement' | translate }}</span>
                <span class="provider-card__meta-value">{{ row.cashReimbursement | currency }}</span>
            </div>
            <div class="provider-card__meta-item provider-card__meta-item--end">
                <span class="provider-card__meta-label">{{ translationPrefix + '.inventory_reembursement' | translate }}</span>
                <span class="provider-card__meta-value">{{ row.inventoryReimbursement | currency }}</span>
            </div>
        </div>

        <div class="provider-card__meta provider-card__meta--full">
            <div class="provider-card__meta-item">
                <span class="provider-card__meta-label">{{ translationPrefix + '.total_reimbursement' | translate }}</span>
                <span class="provider-card__meta-value">{{ row.totalReimbursement | currency }}</span>
            </div>
        </div>

        <div class="provider-card__meta provider-card__meta--full">
            <div class="provider-card__meta-item">
                <span class="provider-card__meta-label">{{ translationPrefix + '.unclaimed_amount' | translate }}</span>
                <span class="provider-card__value">{{ row.unclaimedAmount | currency }}</span>
            </div>
        </div>
    </div>
</div>
